import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { AgregarEmpleadosBase } from 'src/app/shared/agregar-empleados/agregar-empleados-base';

@Component({
  selector: 'app-asignacion-equipo-desarrollo',
  templateUrl: '../../../proyectos/admin-proyectos/modal-agregar-proyecto/agregar-empleados-proyecto/add-emp-proy.component.html',
  styleUrls: ['../modal-agregar-etapa.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule
  ],
})
export class AsignacionEquipoDesarrolloComponent extends AgregarEmpleadosBase {
  protected override readonly idArea = 1;
}
